var map = {
	"./app-logo-text-dreki.svg": [
		78141,
		[
			4705
		]
	],
	"./app-logo-text-halvar.svg": [
		80440,
		[
			1896
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 7 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 58692;
module.exports = webpackAsyncContext;